import { render, staticRenderFns } from "./DefaultCard.vue?vue&type=template&id=18a0e91e"
import script from "./DefaultCard.vue?vue&type=script&lang=js"
export * from "./DefaultCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports